import { BitmapLayer } from '@deck.gl/layers';
import { ImageLoader } from '@loaders.gl/images';
import { load } from '@loaders.gl/core';
import * as layerOps from '../../api/Layers/layer-operations';
import adaptURL from '../adapt-url';

const buildDeckGeoImageLayer = async ({ layer, FindLayerVisible, activeLayers }) => {
  try {
    // const url = layerOps.getURL(layer);
    const url = adaptURL(
      ' https://www.dropbox.com/s/3g9tnlegjedrecx/AP_26688_FBS_F3330_RT1.inc_map.tif?dl=0'
    );
    const image = await load(url, ImageLoader);
    const topLeft = layerOps.getTopLeft(layer);
    const topRight = layerOps.getTopRight(layer);
    const bottomLeft = layerOps.getBottomLeft(layer);
    const bottomRightLat = bottomLeft.lat + topRight.lat - topLeft.lat;
    const bottomRightLNG = bottomLeft.lng + topRight.lng - topLeft.lng;
    const bounds = [
      [bottomLeft.lng, bottomLeft.lat],
      [topLeft.lng, topLeft.lat],
      [topRight.lng, topRight.lat],
      [bottomRightLNG, bottomRightLat]
    ];
    return new BitmapLayer({
      id: 'bitmap-layer',
      bounds,
      visible: FindLayerVisible(layerOps.getId(layer)),
      image,
      opacity: 1,
      updateTriggers: {
        visible: [activeLayers]
      }
    });
  } catch (error) {
    console.error(error);
    throw new Error(error.message);
  }
};

export default buildDeckGeoImageLayer;
